import React from "react";
import { Icon, chakra, useMultiStyleConfig } from "@chakra-ui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
export function SelectClearButton({ onClick, ...props }) {
    const styles = useMultiStyleConfig("SelectClearButton");
    return (React.createElement(chakra.button, { __css: styles["button"], "aria-label": "Clear selection", "data-testid": "select-clear", onClick: (event) => {
            event.stopPropagation();
            onClick?.(event);
        }, ...props },
        React.createElement(Icon, { as: XMarkIcon, __css: styles["icon"] })));
}
